<div class="mobile-fixed-panel" #panel>
  <ng-content></ng-content>
</div>
